import React from "react";
import arrow from "../../../Assets/Image/svg/arrowdown.svg";
function Accordion(props) {
    return (
        <div className="Accordion" key={props.id}>
            <div className="bg-white-dark border-solid border-[1px] border-purple rounded-[16px] shadow-btn overflow-hidden">
                <div className="collapsible-item">
                    <input
                        type="checkbox"
                        id={`tab-${props.id}`}
                        className=" opacity-0 absolute"
                    />
                    <label
                        className="collapsible-item-label text-[1.6rem] leading-[3.2rem] cursor-pointer font-bold flex justify-between text-primary-dark pr-[2.5rem] pl-[2.9rem] py-[1.8rem]"
                        htmlFor={`tab-${props.id}`}
                    >
                        {props.label}
                        <img src={arrow} alt={arrow} className=" w-[2rem] " />
                    </label>
                    <div className="collapsible-item-content bg-white-dark font-normal text-[1.8rem] leading-[3.2rem] text-[rgba(33, 33, 33, 0.9)] ">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Accordion;
